__turbopack_context__.v({
  "body": "ModalBase-module-scss-module__jpLnJW__body",
  "btn": "ModalBase-module-scss-module__jpLnJW__btn",
  "close": "ModalBase-module-scss-module__jpLnJW__close",
  "description": "ModalBase-module-scss-module__jpLnJW__description",
  "footer": "ModalBase-module-scss-module__jpLnJW__footer",
  "footerBtns": "ModalBase-module-scss-module__jpLnJW__footerBtns",
  "icon": "ModalBase-module-scss-module__jpLnJW__icon",
  "iconContainer": "ModalBase-module-scss-module__jpLnJW__iconContainer",
  "root": "ModalBase-module-scss-module__jpLnJW__root",
  "title": "ModalBase-module-scss-module__jpLnJW__title",
});
